module.exports = __webpack_public_path__ + "./img/8c5ce1953f70b125150cc53bac615dc3.png";